import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Estimate } from '@/types/estimate';

export interface FollowUpEstimateInput {
  id: string;
  followUpDate: string;
}

export function useFollowUpEstimate() {
  const queryClient = useQueryClient();

  return useApiMutation<Estimate, FollowUpEstimateInput>({
    mutationFn: ({ id, followUpDate }) =>
      apiPost<Estimate>(operationsClient, opsEstimateEndpoints.followUp(id), { followUpDate }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(data.id) });
      toast.success('Follow-up scheduled');
    },
  });
}
